// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"View2_wrapper__MPLAV","topRow":"View2_topRow__26jrv","user":"View2_user__23G8b","mainUser":"View2_mainUser__2SaZn","bottomRow":"View2_bottomRow__1rJwb"};